import { createTransport } from "./transportFactory.js";

const { transport, baseUrl } = createTransport("campaigns");

export const marketingTransport = transport;
export const MARKETING_BASE_URL = baseUrl;
